import * as React from 'react';

export class PocketsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
        <waffle.blocks.FilterBlock>
          <waffle.filters.BusinessApiFilter/>
          <waffle.filters.EnumFilter
              enumName='domains.pockets.models.PocketState'
              filterKey="state"
              emptySelectedString="All States"
              allowSelectMultiple={true}
          />
           <waffle.filters.EnumFilter
              enumName='domains.pockets.models.PocketType'
              filterKey="type"
              emptySelectedString="All Types"
              allowSelectMultiple={true}
          />
        </waffle.blocks.FilterBlock>
    )
  }
}